<div class="d-flex justify-content-between align-items-center ml-4 mt-4">
    <h4 class="card-label mb-0" (click)="getAllEstProcs()">Estimates</h4>
    <div class="mr-2">
        <button type="button" class="btn btn-outline-secondary mr-2" (click)="openModalOldEstimates()">
            <i class="las la-history"></i> Old Estimates
        </button>
        <button type="button" class="btn btn-outline-primary mr-2" (click)="getEstGroupsList()">
            <i class="las la-clipboard-list"></i> Premade Estimates
        </button>
        <!-- <button class="btn btn-success" (click)="openApprovalModal()"
            [disabled]="!petService.pet_estimate.estimate_def || petService.pet_estimate.estimate_def.length === 0 || getTotalCost() === 0">
            <i class="las la-signature"></i> Approve & Sign
        </button> -->
    </div>
</div>

<div class="card-body card-scroll h-500px p-1 pt-3">
    <form novalidate (ngSubmit)="onStatInput()" #formAddProcedures="ngForm">
        <div class="table-responsive">
            <table class="table align-middle table-bordered my-0">
                <thead>
                    <tr class="table-secondary fw-bold fs-6 text-gray-800" style="border: none !important;"
                        *ngIf="selectedGroup">
                        <th colspan="6" class="py-2">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex align-items-center">
                                    <span class="text-uppercase text-muted mr-2">Collection: </span>
                                    <!-- <span class="h6 mb-0 text-dark">{{ selectedGroup?.description || 'None selected' }}</span> -->
                                    <div class="border rounded p-2 d-flex align-items-center justify-content-between"
                                        style="background-color: rgb(170, 240, 209);">
                                        <span class="h6 mb-0 text-dark">&nbsp;&nbsp; {{ selectedGroup?.description }}
                                            &nbsp;&nbsp;</span>
                                        <i class="las la-times" style="font-size: 1.5rem; cursor: pointer;color: #000;"
                                            (click)="clearSelectedGroup()"></i>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-primary" (click)="transferAllToPVL()">
                                    <i class="las la-truck-loading"></i> Transfer All to PVL
                                </button>
                            </div>
                        </th>
                    </tr>
                    <tr class="table-secondary fw-bold fs-6 text-gray-800" style="border: none !important; ">

                        <th colspan="2" style="vertical-align: initial;">
                            <div class="d-inline-grid align-items-center" style="width: 100%;">
                                <div class="d-flex">
                                    <input type="text" autocomplete="off" class="form-control form-control-sm mr-2"
                                        required name="_code_name" [(ngModel)]="filterText" (keydown)="search($event)"
                                        style="flex: 3;">
                                </div>
                                <div class="list-group button-container" style="max-height: 200px;overflow-y: auto;"
                                    *ngIf="buscador_activo">
                                    <button type="button"
                                        class="list-group-item list-group-item-action list-group-item-sm"
                                        *ngFor="let item of suggestedWordsArray"
                                        (click)="select(item)">
                                        {{ item.code_name + " " + item.procedure_desc }}
                                    </button>
                                </div>
                            </div>
                        </th>

                        <th style="vertical-align: initial;">
                            <div class="btn-group btn-group-sm" role="group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                    data-toggle="dropdown" aria-expanded="false">
                                    {{ txtchar || 'SELECT STATUS' }}
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:void(0)" (click)="onStatusBtn('R', formAddProcedures)">R - Request</a>
                                    <a class="dropdown-item" href="javascript:void(0)" (click)="onStatusBtn('T', formAddProcedures)">T - Treatment</a>
                                    <a class="dropdown-item" href="javascript:void(0)" (click)="onStatusBtn('S', formAddProcedures)">S - Suggested</a>
                                </div>
                            </div>
                        </th>
                        <th style="vertical-align: initial;">
                        </th>
                        <th style="vertical-align: initial;">
                            TOTAL: {{ (selectedItems.size > 0 ? selectedTotal : filteredTotal) | currency }}
                            <small *ngIf="selectedItems.size > 0" class="d-block text-muted">
                                ({{ selectedItems.size }} selected)
                            </small>
                        </th>
                    </tr>
                    <tr class="fw-bold fs-6 text-gray-800 table-dark">
                        <th width="5%">

                        </th>
                        <th>
                            Procedure
                        </th>
                        <th width="35%">
                            Description
                        </th> 
                        <th width="15%">
                            Req date
                        </th>
                        <th width="12%">
                            Total Cost
                        </th>

                    </tr>
                </thead>

                <tbody *ngFor="let item of filteredTable; let i = index">
                    <tr class="badge-hand" data-bs-toggle="tooltip" data-placement="top" [title]="getTooltip(item)"
                        style="font-size: smaller !important;">
                        <td style="text-align: center;">
                            <button type="button" class="btn btn-secondary btn-sm btn-icon" (click)="view(item)"
                                *ngIf="item.children && item.children.length > 0">
                                <i class="la la-search"></i>
                            </button>
                        </td>
                        <td>
                            <div class="d-inline-flex align-items-center" style="width: 100%;">
                                <button type="button" class="btn btn-secondary btn-sm col-lg-8 col-md-8 col-sm-6"
                                    [ngStyle]="{'background-color': getColor(item.status) }">
                                    {{ item.code_name }}
                                </button>
                                <div class="dropdown col-lg-4 col-md-4 col-sm-6">
                                    <button class="btn btn-sm btn-secondary mr-1 dropdown-toggle" type="button"
                                        data-toggle="dropdown" [ngStyle]="{'background-color': getColor(item.status) }"
                                        aria-haspopup="true" aria-expanded="false">
                                        {{ item.status }}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" (click)="statusChanged(item, button)"
                                            *ngFor="let button of getStatusOption(item.status)">
                                            {{ button }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </td>

                        <td style="vertical-align:middle;">
                            {{ item.procedure_desc }}
                        </td> 
                        <td style="vertical-align:middle;">
                            {{ item.req_date }}
                        </td>
                        <td style="vertical-align:middle;">
                            {{ getRowTotalCost(item) | currency }}
                        </td>
 
                    </tr>
                    <tr *ngIf="item.visible">
                        <td></td>
                        <td colspan="2">
                            <table class="table table-borderless table-sm m-0">
                                <tbody>
                                    <tr class="badge-hand" *ngFor="let child of item.children" data-bs-toggle="tooltip"
                                        data-placement="top" [title]="getTooltip(child)">
                                        <td>
                                            <span class="form-control form-control-sm"
                                                [ngStyle]="{'background-color': getColor(child.status) }">
                                                {{ child.code_name }} - {{ child.procedure_desc }}
                                            </span>
                                        </td>
                                        <td style="max-width:40px;">
                                            <div class="dropdown">
                                                <button class="btn btn-secondary btn-sm mr-1 dropdown-toggle"
                                                    type="button" data-toggle="dropdown"
                                                    [ngStyle]="{'background-color': getColor(child.status) }"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    {{ child.status }}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item"
                                                        *ngFor="let button of getStatusOption(child.status)">
                                                        {{ button }}
                                                    </a>
                                                </div>
                                            </div>

                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>
<style>
    .break {
        flex-basis: 100%;
        height: 0;
    }

    .ng-autocomplete {
        width: 600px;
        width: auto !important;
        display: flex !important;
    }

    .table-dark td,
    .table-dark th {
        background-color: #444c53;
    }

    /* Portrait paper feel */
    .estimate-dialog {
        max-width: 900px;
        /* ~A4 width at typical zoom */
    }
</style>











<!-- Combined Modal for displaying estimates with tabs -->
<div class="modal fade" id="modalEstGroups" tabindex="-1" role="dialog" aria-labelledby="modalEstGroupsLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalEstimatesLabel">Premade Estimates</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Bootstrap Tabs -->
                <ul class="nav nav-tabs" id="estimatesTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="pet-estimates-tab" data-toggle="tab" href="#pet-estimates"
                            role="tab" aria-controls="pet-estimates" aria-selected="true">
                            <i class="fas fa-paw mr-2"></i> Pet's Estimates
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="generic-estimates-tab" data-toggle="tab" href="#generic-estimates"
                            role="tab" aria-controls="generic-estimates" aria-selected="false">
                            <i class="fas fa-clipboard-list mr-2"></i> Generic Estimates
                        </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content mt-3" id="estimatesTabContent">
                    <!-- Pet's Estimates Tab -->
                    <div class="tab-pane fade show active" id="pet-estimates" role="tabpanel"
                        aria-labelledby="pet-estimates-tab">
                        <div class="table-responsive">
                            <p-table [value]="petEstimates" [paginator]="true" [rows]="10" class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 25%;" scope="col">Estimate Name</th>
                                        <th style="width: 30%;" scope="col">Remarks</th>
                                        <th style="width: 10%;" scope="col">Total</th>
                                        <th style="width: 17%;" scope="col">Created Date</th>
                                        <th style="width: 18%;" scope="col">Created By</th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr (click)="getEstimateItemsBtn(item, false)">
                                        <td>
                                            <a href="javascript:void(0)"
                                                style="color: #007bff; text-decoration: underline; cursor: pointer;">
                                                {{item.description}}
                                            </a>
                                        </td>
                                        <td>{{item.remarks}}</td>
                                        <td>${{item.total | number:'1.2-2'}}</td>
                                        <td>{{item.date_created | date:'MM/dd/yyyy'}}</td>
                                        <td>{{item.created_by}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <!-- Generic Estimates Tab -->
                    <div class="tab-pane fade" id="generic-estimates" role="tabpanel"
                        aria-labelledby="generic-estimates-tab">
                        <div class="table-responsive">
                            <p-table [value]="genericEstimates" [paginator]="true" [rows]="10"
                                class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 25%;" scope="col">Estimate Name</th>
                                        <th style="width: 30%;" scope="col">Remarks</th>
                                        <th style="width: 10%;" scope="col">Total</th>
                                        <th style="width: 17%;" scope="col">Created Date</th>
                                        <th style="width: 18%;" scope="col">Created By</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr (click)="getEstimateItemsBtn(item, true)">
                                        <td>
                                            <a href="javascript:void(0)"
                                                style="color: #007bff; text-decoration: underline; cursor: pointer;">
                                                {{item.description}}
                                            </a>
                                        </td>
                                        <td>{{item.remarks}}</td>
                                        <td>${{item.total | number:'1.2-2'}}</td>
                                        <td>{{item.date_created | date:'MM/dd/yyyy'}}</td>
                                        <td>{{item.created_by}}</td>
                                    </tr>
                                </ng-template>

                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-primary" (click)="openNewEstGroup()"><i class="las la-plus"></i>
                    Create New</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalNewEstGroup" tabindex="-1" role="dialog" aria-labelledby="modalEstGroupLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalEstGroupLabel">Create New Estimate Group</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <form #formNewEst="ngForm" (ngSubmit)="createEstGroup()" novalidate>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="estGroupName" class="form-label">Group Name</label>
                        <input id="estGroupName" name="estGroupName" class="form-control" type="text"
                            [(ngModel)]="estimateService.new_est_group.description" required />
                    </div>

                    <div class="mb-3">
                        <label for="estGroupType" class="form-label">Estimate Type</label>
                        <select id="estGroupType" name="estGroupType" class="form-control"
                            [(ngModel)]="estimateService.new_est_group.type" required>
                            <option value="">Select type</option>
                            <option value="P">({{ petService.pet.pet_name }}) Pet Estimate</option>
                            <option value="G">Generic Estimate</option>

                        </select>
                    </div>

                    <div class="mb-3">
                        <label for="estGroupRemarks" class="form-label">Remarks</label>
                        <textarea id="estGroupRemarks" name="estGroupRemarks" class="form-control" rows="2"
                            [(ngModel)]="estimateService.new_est_group.remarks" required></textarea>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary" [disabled]="formNewEst.invalid">Create</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- Combined Modal for displaying old estimates with tabs -->
<div class="modal fade" id="modalOldEstimates" tabindex="-1" role="dialog" aria-labelledby="modalOldEstimatesLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalOldEstimatesLabel">Old Estimates</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Bootstrap Tabs -->
                <ul class="nav nav-tabs" id="estimatesTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="old-pet-estimates-tab" data-toggle="tab"
                            href="#old-pet-estimates" role="tab" aria-controls="old-pet-estimates" aria-selected="true">
                            <i class="fas fa-paw mr-2"></i> Pet's Estimates
                        </a>
                    </li>
                    <li class="nav-item" role="presentation">
                        <a class="nav-link" id="old-generic-estimates-tab" data-toggle="tab"
                            href="#old-generic-estimates" role="tab" aria-controls="old-generic-estimates"
                            aria-selected="false">
                            <i class="fas fa-clipboard-list mr-2"></i> Generic Estimates
                        </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content mt-3" id="estimatesTabContent">
                    <!-- Pet's Estimates Tab -->
                    <div class="tab-pane fade show active" id="old-pet-estimates" role="tabpanel"
                        aria-labelledby="old-pet-estimates-tab">
                        <div class="table-responsive">
                            <p-table [value]="petService.pet_estimates" [paginator]="true" [rows]="10"
                                class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Estimate Name</th>
                                        <th scope="col">Date Added</th>
                                        <th scope="col">Total Charge</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr (click)="openModalOldEstimateDef(item)">
                                        <td>{{item.estimate_name}}</td>
                                        <td>{{item.date_added}}</td>
                                        <td>${{item._total_charge}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <!-- Generic Estimates Tab -->
                    <div class="tab-pane fade" id="old-generic-estimates" role="tabpanel"
                        aria-labelledby="old-generic-estimates-tab">
                        <div class="table-responsive">
                            <p-table [value]="petService.pet_generic_estimates" [paginator]="true" [rows]="10"
                                class="table table-bordered">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Estimate Name</th>
                                        <th scope="col">Date Added</th>
                                        <th scope="col">Total Charge</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr (click)="openModalOldEstimateDef(item)">
                                        <td>{{item.estimate_name}}</td>
                                        <td>{{item.date_added}}</td>
                                        <td>${{item._total_charge}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalOldEstimateDef" tabindex="-1" role="dialog" aria-labelledby="modalOldEstimateDefLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalOldEstimateDefLabel">Old Estimate Definition</h5>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Quantity</th>
                                <th scope="col">Code Name</th>
                                <th scope="col">Procedure Description</th>
                                <th scope="col">Category</th>
                                <th scope="col">Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of this.petService.pet_estimate.estimate_def">
                                <tr *ngIf="item.link_count !== 0">
                                    <td> {{ item.link_count }}</td>
                                    <td>
                                        {{ item.code_name }}
                                        <!-- <div class="d-inline-flex align-items-center" style="width: 100%;">
                                            <button type="button" class="btn btn-secondary col-8"
                                                style="padding: 0.25rem 1rem !important;" >
                                                {{ item.code_name }}
                                            </button> 
                                            <div class="dropdown col-4">
                                                <button class="btn btn-secondary mr-1 dropdown-toggle" type="button"
                                                    data-toggle="dropdown" style="padding: 0.25rem 1rem !important;" 
                                                    aria-haspopup="true" aria-expanded="false">
                                                    {{item.status}}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item"  
                                                        *ngFor="let button of getStatusOption('R')">
                                                        {{ button.desc }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div> -->
                                    </td>
                                    <td>{{ item.procedure_desc }}</td>
                                    <td>{{ item.code_category}}</td>
                                    <td>{{ item.link_cost | currency }}</td>
                                </tr>
                            </ng-container>

                            <!-- Total Row -->
                            <tr class="table-warning fw-bold"
                                *ngIf="petService.pet_estimate.estimate_def && petService.pet_estimate.estimate_def.length > 0">
                                <td colspan="4" class="text-end">
                                    <strong>Total:</strong>
                                </td>
                                <td>
                                    <strong>{{ getTotalCost() | currency }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="applyOldEstDef()"><i class="las la-random"></i>
                    Transfer to Premade-Estimate</button>
            </div>
        </div>
    </div>
</div>